// extracted by mini-css-extract-plugin
module.exports = {"t1aocwjm":"t1aocwjm"};